import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "category-node"
};
const _hoisted_2 = {
  key: 1,
  class: "w-5"
};
const _hoisted_3 = {
  class: "w-6 h-6 flex items-center justify-center text-slate-400"
};
const _hoisted_4 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_5 = ["d"];
const _hoisted_6 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_7 = {
  class: "flex-1 text-sm font-medium truncate"
};
const _hoisted_8 = {
  class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity"
};
const _hoisted_9 = {
  key: 0,
  class: "ml-4 border-l border-slate-200 pl-2 mt-1"
};
import { ref, computed } from 'vue';
export default {
  __name: 'CategoryTreeNode',
  props: {
    node: {
      type: Object,
      required: true
    },
    selectedId: {
      type: Number,
      default: null
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  emits: ['select', 'edit', 'delete'],
  setup(__props) {
    const props = __props;
    const isExpanded = ref(true);
    const hasChildren = computed(() => {
      return props.node.children && props.node.children.length > 0;
    });
    function toggleExpand() {
      isExpanded.value = !isExpanded.value;
    }
    return (_ctx, _cache) => {
      const _component_CategoryTreeNode = _resolveComponent("CategoryTreeNode", true);
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer transition-colors group", [__props.selectedId === __props.node.id ? 'bg-primary-50 text-primary-700' : 'hover:bg-slate-100 text-slate-700']]),
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('select', __props.node))
      }, [hasChildren.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _withModifiers(toggleExpand, ["stop"]),
        class: "p-0.5 rounded hover:bg-slate-200 transition-colors"
      }, [(_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["w-4 h-4 transition-transform duration-200", {
          'rotate-90': isExpanded.value
        }]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      }, null, -1)]))], 2))])) : (_openBlock(), _createElementBlock("div", _hoisted_2)), _createElementVNode("div", _hoisted_3, [__props.node.icon ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: __props.node.icon
      }, null, 8, _hoisted_5)])) : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[7] || (_cache[7] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
      }, null, -1)]))]))]), _createElementVNode("span", _hoisted_7, _toDisplayString(__props.node.name), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('edit', __props.node), ["stop"])),
        class: "p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors cursor-pointer",
        title: "编辑"
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
      })], -1)]))]), _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.$emit('delete', __props.node), ["stop"])),
        class: "p-1 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors cursor-pointer",
        title: "删除"
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      })], -1)]))])])], 2), hasChildren.value && isExpanded.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.children, child => {
        return _openBlock(), _createBlock(_component_CategoryTreeNode, {
          key: child.id,
          node: child,
          "selected-id": __props.selectedId,
          depth: __props.depth + 1,
          onSelect: _cache[3] || (_cache[3] = $event => _ctx.$emit('select', $event)),
          onEdit: _cache[4] || (_cache[4] = $event => _ctx.$emit('edit', $event)),
          onDelete: _cache[5] || (_cache[5] = $event => _ctx.$emit('delete', $event))
        }, null, 8, ["node", "selected-id", "depth"]);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};